import React, { useEffect, useState } from "react";
import { FaSuitcase } from "react-icons/fa";
import { Link } from "react-router-dom";

const PricingCards = () => {
  const [categories, setCategories] = useState({});

  useEffect(() => {
    fetch("https://admin.socioloom.com/api/pricing_api.php")
      .then((res) => res.json())
      .then((data) => setCategories(data))
      .catch((err) => console.error("Error fetching pricing:", err));
  }, []);

  const getOriginalPrice = (discounted) => {
    const num = parseFloat(discounted);
    return Math.round(num / 0.8); // 20% discount
  };

  return (
    <section className="bg-white text-black py-12">
      <div className="container mx-auto px-6">
        <h2 className="text-center text-5xl font-bold mb-8 text-[#07c991a8]">
          Our Pricing & Services
        </h2>
        <p className="text-center text-3xl text-gray-600 mb-10 text-lg">
          We provide <span className="font-semibold text-[#07c991a8]">Free Logo</span> to our clients,  
          along with <span className="font-semibold text-[#07c991a8]">6 Months Hosting & Support</span> in every package.
        </p>

        {Object.keys(categories).map((cat, idx) => (
          <div key={idx} className="mb-12">
            <h3 className="text-xl font-semibold mb-6">{cat}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {categories[cat].map((plan, index) => {
                const originalPrice = getOriginalPrice(plan.price);
                return (
                  <div
                    key={index}
                    className="bg-[#205c4ba8] text-white rounded-3xl p-8 flex flex-col justify-between shadow-lg"
                  >
                    {/* Title + Icon */}
                    <div className="flex justify-between items-center mb-4">
                      <h4 className="text-2xl font-bold">{plan.title}</h4>
                      <span className="bg-white text-black p-2 rounded-full">
                        <FaSuitcase />
                      </span>
                    </div>

                    {/* Features */}
                    <ul className="space-y-2 mb-6">
                      {plan.features.map((feature, i) => (
                        <li key={i} className="flex items-center gap-2">
                          <span className="text-green-400">✓</span> {feature}
                        </li>
                      ))}
                    </ul>

                    {/* Price */}
                    <div className="mb-6">
                      {/* <span className="text-lg line-through text-gray-200">
                        ${originalPrice.toLocaleString()}
                      </span> */}
                      <br />
                      <span className="text-3xl font-bold">${plan.price}</span>
                      <span className="ml-2 text-sm">{plan.duration}</span>
                    </div>

                    {/* Button */}
                    <button className="bg-white text-black font-semibold py-3 px-6 rounded-full hover:bg-gray-200 transition">
                      <Link to="../contact">Get Started</Link>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PricingCards;
